(function () {
  'use strict';
  const GUARDIANS = ['Panda', 'Dog', 'Cat'];
  const PILLOWS = ['V1', 'V2', 'V3', 'V4'];
  const initialState = () => ({pack: 'single', guardians: ['Panda', 'Panda'], pillow: 'V1', addons: {mount: true, pillow: true, mystery: true}});
  function validState(state) {
    return Boolean(state && state.addons) && ['single', 'family'].includes(state.pack) && Array.isArray(state.guardians) && state.guardians.length === 2 && state.guardians.every(value => GUARDIANS.includes(value)) && PILLOWS.includes(state.pillow) && ['mount', 'pillow', 'mystery'].every(kind => typeof state.addons[kind] === 'boolean');
  }
  function optionsFor(state) {
    if (!validState(state)) return null;
    const pillow = state.addons.pillow ? state.pillow : 'None';
    if (state.pack === 'family') {
      const pair = state.guardians.slice().sort((a, b) => GUARDIANS.indexOf(a) - GUARDIANS.indexOf(b));
      return [pair.join(' + '), pillow, state.addons.mystery ? 'Yes' : 'No'];
    }
    const extras = state.addons.mount && state.addons.mystery ? 'Mount + Mystery' : state.addons.mount ? 'Mount' : state.addons.mystery ? 'Mystery' : 'None';
    return [state.guardians[0], pillow, extras];
  }
  function expectedUSD(state) {
    return (state.pack === 'single' ? 11999 : 19999) + (state.addons.pillow ? 2499 : 0) + (state.addons.mystery ? state.pack === 'single' ? 1599 : 1499 : 0) + (state.pack === 'single' && state.addons.mount ? 1499 : 0);
  }
  function allStates() {
    const states = [];
    for (const pack of ['single', 'family']) for (const a of GUARDIANS) for (const b of GUARDIANS) for (const pillow of PILLOWS) for (const mount of [false, true]) for (const includePillow of [false, true]) for (const mystery of [false, true]) states.push({pack, guardians: [a, b], pillow, addons: {mount, pillow: includePillow, mystery}});
    return states;
  }
  function key(options) { return JSON.stringify(options); }
  function variantOptions(variant) { return Array.isArray(variant.options) && variant.options.length === 3 ? variant.options : [variant.option1, variant.option2, variant.option3]; }
  function indexCatalog(catalog) {
    const indexes = {};
    const ids = new Set();
    if (!catalog || catalog.shopCurrency !== 'USD') return {valid: false, indexes};
    for (const pack of ['single', 'family']) {
      const parent = catalog[pack];
      const handle = pack === 'single' ? 'peekseat-single-pack' : 'peekseat-family-pack';
      if (!parent || parent.handle !== handle || parent.ready !== true || !Array.isArray(parent.variants) || parent.variants.length !== 60) return {valid: false, indexes};
      const map = new Map();
      for (const variant of parent.variants) {
        const optionKey = key(variantOptions(variant));
        if (!/^\d+$/.test(String(variant.id)) || !Number.isInteger(variant.price) || variant.price <= 0 || map.has(optionKey) || ids.has(String(variant.id))) return {valid: false, indexes};
        ids.add(String(variant.id));
        map.set(optionKey, variant);
      }
      const expected = new Map(allStates().filter(state => state.pack === pack).map(state => [key(optionsFor(state)), expectedUSD(state)]));
      if (map.size !== expected.size || [...expected].some(([optionKey, price]) => !map.has(optionKey) || catalog.currency === 'USD' && map.get(optionKey).price !== price)) return {valid: false, indexes};
      indexes[pack] = map;
    }
    return {valid: true, indexes};
  }
  function resolve(state, indexed) {
    if (!validState(state) || !indexed.valid) return null;
    const variant = indexed.indexes[state.pack].get(key(optionsFor(state)));
    return variant && variant.available === true ? variant : null;
  }
  function propertiesFor(state) {
    const extras = [];
    if (state.pack === 'single' && state.addons.mount) extras.push('Camera Mount');
    if (state.addons.pillow) extras.push('Kids Car Neck Pillow ' + state.pillow);
    if (state.addons.mystery) extras.push('Mystery Box For Babies');
    const properties = {'_PeekSeatOffer': state.pack, 'Guardian 1': state.guardians[0], 'Included items': state.pack === 'family' ? 'Camera Mount + Camera Straps (no extra charge)' : 'Camera Straps (no extra charge)', 'Optional extras': extras.join(', ') || 'None'};
    if (state.pack === 'family') properties['Guardian 2'] = state.guardians[1];
    return properties;
  }
  function decorateFormData(data, variantId, properties) {
    const id = String(variantId);
    const itemKeys = [...data.keys()].filter(name => /^items\[\d+\]\[id\]$/.test(name));
    if (itemKeys.length) {
      for (const property of Object.keys(properties)) data.delete('properties[' + property + ']');
      for (const name of itemKeys) if (String(data.get(name)) === id) {
        const prefix = name.replace(/\[id\]$/, '[properties]');
        for (const [property, value] of Object.entries(properties)) data.set(prefix + '[' + property + ']', value);
      }
    } else if (String(data.get('id')) === id) for (const [property, value] of Object.entries(properties)) data.set('properties[' + property + ']', value);
    return data;
  }
  function guardSubmission(event, form, state, indexed, busy) {
    const variant = resolve(state, indexed);
    if (!variant || busy) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return null;
    }
    const input = form.querySelector('input.product-variant-id[name="id"]');
    if (!input) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return null;
    }
    input.value = String(variant.id);
    return {variant, properties: propertiesFor(state)};
  }
  function cameraMediaId(catalog, guardian) {
    const camera = catalog && catalog.camera;
    if (!camera || !Array.isArray(camera.variants)) return null;
    const variant = camera.variants.find(item => item.option1 === guardian || Array.isArray(item.options) && item.options[0] === guardian);
    if (!variant) return null;
    const featured = Array.isArray(camera.featuredMedia) && camera.featuredMedia.find(item => String(item.variantId) === String(variant.id));
    const mediaId = featured && featured.mediaId || variant.featured_media && variant.featured_media.id;
    return /^\d+$/.test(String(mediaId)) ? String(mediaId) : null;
  }
  function activateCameraMedia(section, catalog, guardian) {
    const mediaId = cameraMediaId(catalog, guardian);
    if (!mediaId || !section || typeof section.querySelectorAll !== 'function') return 0;
    let activated = 0;
    section.querySelectorAll('media-gallery').forEach(gallery => {
      if (typeof gallery.setActiveMedia !== 'function' || !gallery.dataset.section) return;
      const target = gallery.dataset.section + '-' + mediaId;
      const viewer = gallery.elements && gallery.elements.viewer;
      if (!viewer || !viewer.querySelector('[data-media-id="' + target + '"]')) return;
      const thumbnails = gallery.elements.thumbnails;
      if (thumbnails && !thumbnails.querySelector('[data-target="' + target + '"]')) return;
      gallery.setActiveMedia(target, false, false);
      activated += 1;
    });
    return activated;
  }
  const core = {GUARDIANS, PILLOWS, initialState, validState, optionsFor, expectedUSD, allStates, indexCatalog, resolve, propertiesFor, decorateFormData, guardSubmission, cameraMediaId, activateCameraMedia};
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (typeof document === 'undefined') return;
  if (window.peekseatNativeOffersBooted) return;
  window.peekseatNativeOffersBooted = true;
  function init(root) {
    if (root.dataset.initialized === 'true') return;
    const section = root.closest('.shopify-section');
    const productForm = section && section.querySelector('product-form.main-product-form');
    const form = productForm && productForm.querySelector('form[data-type="add-to-cart-form"]');
    const dataNode = root.querySelector('[data-peekseat-catalog]');
    if (!form || !dataNode) return;
    root.dataset.initialized = 'true';
    let catalog;
    try { catalog = JSON.parse(dataNode.textContent); } catch (_) { return; }
    const indexed = indexCatalog(catalog);
    const labels = catalog.labels || {};
    let state = initialState();
    let pending = null;
    const idInput = form.querySelector('input.product-variant-id[name="id"]');
    const button = form.querySelector('[type="submit"]');
    const status = root.querySelector('[data-offer-status]');
    const money = cents => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: catalog.currency}).format(cents / 100); } catch (_) { return String(cents / 100); }
    };
    function setProperties(properties) {
      form.querySelectorAll('[data-peekseat-property]').forEach(input => input.remove());
      for (const [property, value] of Object.entries(properties)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + property + ']';
        input.value = value;
        input.dataset.peekseatProperty = 'true';
        form.appendChild(input);
      }
    }
    function selectedImage(kind) {
      const item = catalog.products && catalog.products[kind];
      if (!item) return '';
      const variant = kind === 'pillow' && Array.isArray(item.variants) && item.variants.find(variant => variant.option1 === state.pillow);
      return variant && variant.featured_image && variant.featured_image.src || item.image || '';
    }
    function amountFor(kind) {
      const off = {...state, guardians: state.guardians.slice(), addons: {...state.addons, [kind]: false}};
      const on = {...off, addons: {...off.addons, [kind]: true}};
      const a = resolve(off, indexed), b = resolve(on, indexed);
      return a && b ? b.price - a.price : null;
    }
    function render() {
      const variant = resolve(state, indexed);
      const valid = Boolean(variant && idInput);
      root.dataset.offerReady = valid ? 'true' : 'false';
      root.hidden = false;
      root.querySelectorAll('[data-pack-panel]').forEach(panel => { panel.hidden = panel.dataset.packPanel !== state.pack; });
      root.querySelectorAll('[data-pack-radio]').forEach(input => { input.checked = input.value === state.pack; });
      root.querySelectorAll('[data-pack-card]').forEach(card => { card.classList.toggle('is-selected', card.dataset.packCard === state.pack); });
      root.querySelectorAll('[data-guardian]').forEach(select => { select.value = state.guardians[Number(select.dataset.guardian)]; });
      root.querySelectorAll('[data-pillow-variant]').forEach(select => { select.value = state.pillow; select.disabled = !state.addons.pillow; });
      root.querySelectorAll('[data-paid-addon]').forEach(input => { input.checked = state.addons[input.dataset.paidAddon]; input.disabled = input.closest('[data-pack-panel]').hidden; });
      root.querySelectorAll('[data-addon-image]').forEach(image => { const src = selectedImage(image.dataset.addonImage); if (src) { image.src = src; image.hidden = false; } else { image.removeAttribute('src'); image.hidden = true; } });
      root.querySelectorAll('[data-addon-price]').forEach(label => {
        const kind = label.dataset.addonPrice;
        const amount = amountFor(kind);
        label.textContent = amount === null ? '' : money(amount);
      });
      root.querySelectorAll('[data-pack-base-price]').forEach(label => {
        const baseState = {...state, pack: label.dataset.packBasePrice, addons: {mount: false, pillow: false, mystery: false}};
        const base = resolve(baseState, indexed);
        label.textContent = base ? money(base.price) : '';
        const compare = label.parentElement.querySelector('[data-pack-compare]');
        const comparePrice = Number(catalog.cameraCompareAt) * (baseState.pack === 'family' ? 2 : 1);
        if (compare) { compare.hidden = !base || !Number.isFinite(comparePrice) || comparePrice <= base.price; compare.textContent = compare.hidden ? '' : money(comparePrice); }
      });
      root.querySelector('[data-offer-total]').textContent = variant ? money(variant.price) : '—';
      status.textContent = valid ? '' : labels.unavailable || '';
      status.hidden = valid;
      if (idInput) idInput.value = variant ? String(variant.id) : '';
      if (valid) setProperties(propertiesFor(state));
      if (button) {
        const required = button.dataset.requiredFields;
        const fieldsValid = required === undefined || required === button.dataset.validFields;
        button.disabled = !valid || !fieldsValid;
      }
      section.querySelectorAll('sticky-atc secondary-variant-select, sticky-atc secondary-variant-select-separate').forEach(picker => { picker.hidden = true; });
      section.querySelectorAll('sticky-atc [id^="sticky-atc-separate-price-"]').forEach(price => { price.textContent = variant ? money(variant.price) : '—'; });
      section.querySelectorAll('sticky-atc [id^="sticky-atc-price-"]').forEach(price => { price.textContent = variant ? money(variant.price) + ' • ' : ''; });
    }
    root.addEventListener('change', event => {
      const control = event.target;
      if (control.matches('[data-pack-radio]')) state.pack = control.value;
      if (control.matches('[data-guardian]')) state.guardians[Number(control.dataset.guardian)] = control.value;
      if (control.matches('[data-pillow-variant]')) state.pillow = control.value;
      if (control.matches('[data-paid-addon]')) state.addons[control.dataset.paidAddon] = control.checked;
      render();
      if (control.matches('[data-guardian]') && Number(control.dataset.guardian) === 0) activateCameraMedia(section, catalog, state.guardians[0]);
    });
    form.addEventListener('submit', event => {
      const busy = Boolean(button && (button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading')));
      pending = guardSubmission(event, form, state, indexed, busy);
      if (pending) setProperties(pending.properties);
      else if (!busy) { status.textContent = labels.unavailable || ''; status.hidden = false; }
    }, true);
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[id^="SectionAtcBtn-"]');
      if (!trigger || document.querySelector('product-form[data-main="true"]') !== productForm) return;
      const busy = Boolean(button && (button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading')));
      pending = guardSubmission(event, form, state, indexed, busy);
      if (pending) setProperties(pending.properties);
    }, true);
    form.addEventListener('formdata', event => {
      if (pending) decorateFormData(event.formData, pending.variant.id, pending.properties);
    });
    render();
    if (typeof customElements !== 'undefined' && typeof customElements.whenDefined === 'function') {
      customElements.whenDefined('media-gallery').then(() => { if (root.isConnected !== false) activateCameraMedia(section, catalog, state.guardians[0]); });
    }
  }
  function syncToggles() { document.querySelectorAll('[data-peekseat-addon-toggle]').forEach(button => { const upsell = button.closest('[data-selected]'); if (upsell) button.setAttribute('aria-pressed', upsell.dataset.selected === 'true' ? 'true' : 'false'); }); }
  function boot() { syncToggles(); document.querySelectorAll('[data-peekseat-native-offer]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('click', event => { if (event.target.closest('[data-peekseat-addon-toggle]')) setTimeout(syncToggles, 0); });
  if (typeof MutationObserver !== 'undefined') new MutationObserver(syncToggles).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['data-selected']});
})();
